@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row && $.row.oppportunity_info) {
    <div
      class="relative w-6rem h-2rem flex align-items-center justify-content-center"
    >
      <img
        class="absolute w-6rem h-2rem"
        src="/assets/img/icons/opportunity-stage-bg.svg"
      />
      <div></div>
      @if ($.row && $.adata && $.row.oppportunity_info) {
        <span
          class="relative z1 text-xs text-primary font-bold w-5rem white-space-nowrap text-overflow-ellipsis overflow-hidden block"
          >{{
            parseOpportunity($.row.oppportunity_info.stage_master_id, $.adata)
              ?.name_primary_language
          }}</span
        >
      }
    </div>
  }
  @if ($.row && $.adata && $.row.oppportunity_info) {
    <small class="text-xxs block text-right-rtl">{{
      $.row.oppportunity_info.board_type
    }}</small>
  }
  @if ($.row && !$.row.oppportunity_info) {
    <div>-</div>
  }
}
